import { useSgpFlowData } from '../hooks/useSgpFlowData';
import SgpFlowScreenView from '../components/SgpFlowScreenView';

/**
 * SgpFlowScreen — thin shell.
 *
 * God-file decomposition: the ~1,760-line data layer (state, effects, handlers,
 * derived values) lives in hooks/useSgpFlowData.js, and the ~720-line render
 * (early-return splash guards + main render) lives in
 * components/SgpFlowScreenView.jsx. This file just wires the two together.
 *
 * The hook returns the exact prop set the view consumes (the return list and the
 * view's signature are generated from the SAME prop list, so they cannot drift),
 * and we spread it straight through — no per-prop threading needed.
 */
const SgpFlowScreen = () => {
  const data = useSgpFlowData();
  return (
    <SgpFlowScreenView {...data} />
  );
};

export default SgpFlowScreen;
